<template>
<!--
  Local URL: http://localhost:8080/vt-fileupload-detail/<int: ID> where ID is the ID of the uploaded file object.
  Required Group Membership: Curator or Admin
  Purpose: This page is for members of the Curators group. It first compares the file with the CURRENT state of the 
  database as opposed to the state of the database when the file was uploaded. This process can take a little bit to 
  complete.
  When it finishes, the page displays the details of the file including what the data looks like according to the 
  system. This gives the curator the opportunity download the file (if desired) to review it before accepting it into 
  the database. Of course, if the curator identifies a problem with the data, they can reject the file also.
-->
  <VTBaseTemplate>
    <b-modal
      id="api-err-modal"
      v-model="apiErrModalShow"
      centered
      scrollable
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      title="Error"
      :header-bg-variant="'warning'"
      :header-text-variant="'light'">
      <span v-html="err_msg"></span>
      <b-button class="mt-3" block @click="hideModal">OK</b-button>
    </b-modal>
    <!-- This modal shows to confirm commiting dataset. -->
    <b-modal
        id="confirm-commit-modal"
        v-model="confirmCommitModalShow"
        centered
        scrollable
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc
        title="Confirm Commit"
        :header-bg-variant="'warning'"
        :header-text-variant="'light'">
        <span v-html="confirmMessage"></span>
        <b-button class="mt-3" variant="success" @click="onCommit(); hideConfirmCommitModal();" block>Commit File</b-button>
        <b-button class="mt-3" @click="hideConfirmCommitModal" block>Cancel</b-button>
    </b-modal>
    <!-- This modal shows while the dataset is being deleted. -->
    <b-modal
      id="warning-modal"
      v-model="workingModalShow"
      centered
      scrollable
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      title="Evaluating File"
      :header-bg-variant="'warning'"
      :header-text-variant="'light'">
      <span v-html="'Comparing the selected file with the current data. This may take several minutes.'"></span>
    </b-modal>
    <br><br><br>
    <div class="w-100 h-100">
      <b-container fluid style="padding-right: 50px; padding-left: 50px;">
        <div class="title-area">
          <center>
            <br><br><br>
            <img
              src="@/assets/images/logos/vectrait_logo.svg"
              class="mr-2"
              width=45px
            />
            <h2>Curate VecTraits File Upload Detail</h2>
          </center>
        </div>
        <b-button v-b-toggle.collapse-instructions variant="primary">Instructions</b-button>
        <b-collapse id="collapse-instructions">
          <div style="padding:15px;">
            <p><b>Curating Files</b></p>
            <p>Approve or Reject this file.</p>
          </div>
        </b-collapse>
        <hr />
        <!-- FILE DETAIL SECTION -->
        <b-row><b-col><b>File Name:</b> {{ file_name }}</b-col></b-row>
        <b-row><b-col><b>File ID:</b> {{ id }}</b-col></b-row>
        <b-row><b-col><b>File Uploader:</b> {{ uploader }}</b-col></b-row>
        <b-row><b-col><b>File Status:</b> {{ status }}</b-col></b-row>
        <b-button variant="primary" @click="downloadFile" size=sm>Download File</b-button>
        <b-row><b-col><b>Notes:</b></b-col></b-row>
        <b-row>
          <b-col cols="12" class="mt-1"> 
            <b-form-textarea id="file-notes-textarea" v-model="notes"></b-form-textarea>
            <b-button style="float: right;" class="ml-1 mt-1" @click="updateNotes()" variant="primary" size=sm>
              Update Notes
            </b-button>
          </b-col>
        </b-row>
        <!-- ERROR SECTION -->
        <span v-if="error_list.length > 0" >
          <h3>Errors:</h3>
          <!-- <VBUploadObjectsTable :tableData="error_list" :objectName="'Error'" :type="'error'"/> -->
          <VBUploadObjectsContinuousTable :tableData="error_list" :objectName="'Error'" :type="'error'"/>
          <b-row style="margin-bottom: 1rem;">
            <b-col>
              <div style="float: right; display: inline;">
                <b-button @click="clearPageState()">Cancel</b-button>
              </div>
            </b-col>
          </b-row>
        </span>
        <!-- SUMMARY SECTION -->
        <span v-else-if="show_summary">
          <h3>Summary:</h3>
          <b-row><b-col><b>Total CSV rows:</b> {{ summary.csv_rows }}</b-col></b-row>
          <b-row><b-col><b>New rows:</b> {{ summary.new_rows }}</b-col></b-row>
          <b-row><b-col><b>New rows in existing datasets:</b> {{ summary.new_rows_existing_datasets }}</b-col></b-row>
          <b-row><b-col><b>Rows already in database:</b> {{ summary.existing_rows }}</b-col></b-row>
          <b-row><b-col><b>Total Datasets in CSV:</b> {{ summary.csv_datasets }}</b-col></b-row>
          <!-- <b-row><b-col><b>New datasets in CSV:</b> {{ summary.new_datasets.join(', ') }}</b-col></b-row> -->
          <b-row><b-col><b>New datasets in CSV:</b> {{ summary.new_dataset_count }}</b-col></b-row>

          <span v-if="summary.unknown_columns.length">
            <b-row style="color: red;">
              <b-col>
                <b>Unrecognized columns in the file that will not be processed:</b> <br>
                {{ summary.unknown_columns.join(', ') }}
              </b-col>
            </b-row>
          </span>
          <b-row>
            <b-col>
              <h4 style="position: absolute; bottom: 0px;">Row Data Summary:</h4>
            </b-col>
            <b-col>
              <b-row>
                  <b-col>
                    <div  style="float: right;">
                      New Row: <div class="color-box" style="background-color: #c3e6cb;"></div>
                    </div>
                  </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div  style="float: right;">
                    New Row in Exising Dataset: <div class="color-box" style="background-color: #ffeeba;"></div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div  style="float: right;">
                    Row Already in Database: <div class="color-box" style="background-color: #f1b0b7;"></div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <VBUploadObjectsContinuousTable :tableData="cptItems" :objectName="'Row Data Summary'" :type="'summary'"/>
          </b-row>
          <!-- <b-table
            ref="table"
            striped 
            hover 
            sticky-header="500px"
            responsive
            selectable
            select-mode='single'
            bordered
            head-variant="light"
            no-border-collapse

            :items="cptItems"
            :fields="fields"
            tbody-tr-class="vt-table-row"
          >
            <template #table-busy>
              <div class="text-danger my-2">
                <b-spinner class="align-left"></b-spinner>
                <strong>&nbsp;Loading...</strong>
              </div>
            </template>
            <template v-slot:head()="field">
                <span :title="field.field.title" style="font-size: small; white-space: nowrap;">
                    {{ field.label }}
                </span>
            </template>
            <template v-slot:cell()="data">
              <span  :title='data.value'>{{ data.value}}</span>
            </template>
          </b-table> -->
          <span v-if = "warning_list.length > 0">
            <h3>Warnings:</h3>
            <VBUploadObjectsContinuousTable :tableData="warning_list" :objectName="'Warning'" :type="'warning'"/>
          </span>
          <div style="margin-bottom: 1rem;">
            <!-- <h4 style="cursor: pointer;" v-b-toggle.collapse-object-summary @click="showObjectSummary = !showObjectSummary"> -->
              <h4 style="cursor: pointer;" @click="showObjectSummary = !showObjectSummary">
              Object Summary:
              <span v-if="showObjectSummary"> [-] </span>
              <span v-else> [+] </span>
            </h4>
            <!-- <b-collapse id="collapse-object-summary"> -->
            <span v-if="showObjectSummary">
              <VBUploadObjectsContinuousTable :tableData="citations_objs" :objectName="'Citation'" :type="'summary'"/>
              <VBUploadObjectsContinuousTable :tableData="contributors_objs" :objectName="'Contributor'" :type="'summary'"/>
              <VBUploadObjectsContinuousTable :tableData="sourceinfos_objs" :objectName="'Source Info'" :type="'summary'"/>
              <VBUploadObjectsContinuousTable :tableData="interactor1s_objs" :objectName="'Interactor 1'" :type="'summary'"/>
              <VBUploadObjectsContinuousTable :tableData="interactor2s_objs" :objectName="'Interactor 2'" :type="'summary'"/>
              <VBUploadObjectsContinuousTable :tableData="expercond_objs" :objectName="'Experimental Condition'" :type="'summary'"/>
              <VBUploadObjectsContinuousTable :tableData="studylocations_objs" :objectName="'Study Location'" :type="'summary'"/>
              <VBUploadObjectsContinuousTable :tableData="traitdesc_objs" :objectName="'Trait Description'" :type="'summary'"/>
              <VBUploadObjectsContinuousTable :tableData="maintable_objs" :objectName="'Main Table'" :type="'summary'"/>
              <div style="margin:5px;" v-if="!summaryObjectsExist" >
                <h4>Uploaded file contains no new objects.</h4>
              </div>
            </span>
            <!-- </b-collapse> -->
          </div>
        </span>
        <!-- END SUMMARIES -->

        <b-row class="mb-2">
          <b-col cols="12" class="mt-1">
            <div style="float: right;" class="ml-1">
              <b-button @click="confirmCommit()" variant="success" block>
                Commit File to Database
              </b-button>
            </div>
            <div style="float: right;" class="ml-1">
              <b-button @click="onReject()" variant="danger" block>Reject</b-button>
            </div>
            <div style="float: right;" class="ml-1">
              <b-button class="button-link" :to="{name: 'curate-vectraits'}" variant="primary" block>
                Return to List
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </VTBaseTemplate>
</template>

<script>
// @ is an alias to /src
import { HTTP } from "@/utilities/http-common";
import VTBaseTemplate from "@/layouts/VTBaseTemplate.vue";
// import VBUploadObjectsTable from "@/components/tables/VBUploadObjectsTable.vue";
import VBUploadObjectsContinuousTable from "@/components/tables/VBUploadObjectsContinuousTable.vue";
import HandleErrors from "@/utilities/handle-errors";

import { mapState } from "vuex";

export default {
    name: "vt-fileupload-detail",
    mixins: [VTBaseTemplate],
    components: {
        VTBaseTemplate,
        // VBUploadObjectsTable,
        VBUploadObjectsContinuousTable
    },
    props: {
      id: String,
    },
    data(){
      return{
        data: [],
        table_data: [],
        fields: [], // dynamically populated by buildFieldsArray()
        summary: {
          new_datasets: [],
          unknown_columns: [],
        },
        show_summary: false,
        file_name: '',
        file_url: '',
        status: '',
        uploader: '',
        notes: '',
        summary_list: [],
        error_list: [],
        warning_list: [],
        citations_objs: [],
        contributors_objs: [],
        sourceinfos_objs: [],
        interactor1s_objs: [],
        interactor2s_objs: [],
        expercond_objs: [],
        studylocations_objs: [],
        traitdesc_objs: [],
        maintable_objs: [],
        err_msg: '',
        apiErrModalShow: false,
        workingModalShow: false,
        showObjectSummary: false,
        confirmCommitModalShow: false,
        confirmMessage: '',
        initialNotes: '',
      };
    },
    created() {
      document.title = "Curate VecTraits File Upload Detail";
    },
    computed: {
      ...mapState("user", ["user", "myGroups"]),
      summaryObjectsExist: function () {
        // return true if there are any elements in any of the object lists
        let summaries = [
          this.citations_objs,
          this.contributors_objs,
          this.sourceinfos_objs,
          this.interactor1s_objs,
          this.interactor2s_objs,
          this.expercond_objs,
          this.studylocations_objs,
          this.traitdesc_objs,
          this.maintable_objs,
        ]
        return summaries.some((array) => array.length != 0);
      },
      cptItems(){
        // add formatting to the row items based on the value in the RowUploadStatus column
        return this.table_data.map((item)=>{
          let tmp=item;
          if (item.RowUploadStatus == "New row"){
            tmp._rowVariant='success';
          } else if (item.RowUploadStatus == "New row in existing dataset"){
            tmp._rowVariant='warning';
          } else if (item.RowUploadStatus == "Row already exists"){
            tmp._rowVariant='danger';
          }
          return tmp;
        })  
    }
    },
    watch: {
    },
    mounted() {
      const that = this;

      this.workingModalShow = true;

      const fd = new FormData();
      fd.append("test", "test");
      //HTTP.get(`/api/vectraits-upload-detail/${this.id}/`, fd)
      HTTP.get(`/api/vectraits-naive-upload-detail/${this.id}/`, fd)
        .then(response => {
          that.table_data = response.data.records;
          that.fields = this.buildFieldsArray(this.table_data);
          that.file_name = response.data.file_details.file_name;
          that.file_url = response.data.file_details.file;
          that.status = response.data.file_details.status;
          that.uploader = response.data.file_details.uploader;
          that.notes = response.data.file_details.notes;
          that.summary = response.data.summary;
          that.error_list = response.data.error_list;
          that.warning_list = response.data.warning_list;
          that.summary_list = response.data.summary_list;
          that.citations_objs = response.data.citations_list;
          that.contributors_objs = response.data.contributors_list;
          that.sourceinfos_objs = response.data.sourceinfos_list;
          that.interactor1s_objs = response.data.interactor1s_list;
          that.interactor2s_objs = response.data.interactor2s_list;
          that.expercond_objs = response.data.experconditions_list;
          that.studylocations_objs = response.data.studylocations_list;
          that.traitdesc_objs = response.data.traitdescriptions_list;
          that.maintable_objs = response.data.maintables_list;
          that.show_summary = true;
          that.workingModalShow = false
          that.initialNotes = response.data.file_details.notes;
        })
        .catch((error) => {
          that.err_msg = HandleErrors.HandleErrors(error);
          that.apiErrModalShow = true;
          that.workingModalShow = false
        });

    },
    methods: {
      hideModal() {
        this.apiErrModalShow = false;
      },
      hideConfirmCommitModal() {
        this.confirmCommitModalShow = false;
      },
      buildFieldsArray(data) {
        // NOTE: IF THERE ARE NO ROWS IN DATA, THIS WILL ERROR OUT.

        // TODO: handle no rows in input. Currently, we are checking that there are rows before calling this
        // function in myProvider().

        // convert each element to an object containing the field name as a key, a sortable key, and tdclass:
        // ie. convert "OriginalID" to 
        // "{ key: 'OriginalID', sortable: true, tdClass: 'text-truncate vt-table-cell' },"
        let field_list = Object.keys(data[0]);

        let field_array = [];

        field_list.forEach(function(fieldName) {
            let field_dict = {};
            field_dict['key'] = fieldName;
            field_dict['sortable'] = true;
            field_dict['tdClass'] = 'text-truncate vt-table-cell';
            field_dict['__rowVariant'] = 'danger';

            field_array.push(field_dict);
        });

        return field_array;
      },
      updateNotes: function () {
        const fd = new FormData();
        fd.append("notes", this.notes);

        HTTP.put(`/api/vectraits-uploads/${this.id}`, fd)
          .then(response => { 
            this.err_msg = response.data.err_msg;
            this.$notify({
              text: "Notes updated successfully!",
              duration: 10000,
              type: "success",
            });
          })
          .catch((error) => {
            this.err_msg = HandleErrors.HandleErrors(error);
            this.apiErrModalShow = true;
          });
          this.initialNotes = this.notes; // assign the newly updated notes
      },
      confirmCommit: function () {
        this.confirmMessage = 'Are you sure you would like to commit this file to the database?';
        this.confirmCommitModalShow = true;
      },
      onCommit: function () {
          const fd = new FormData();
          fd.append("uploaded_file_id", this.id);
          fd.append("notes", this.notes);
          //HTTP.post("/api/vectraits-commit/", fd)
          HTTP.post("/api/vectraits-naive-commit/", fd)
            .then(response => { 
              this.err_msg = response.data.err_msg;
              this.$notify({
                text: "File committed successfully!",
                duration: 10000,
                type: "success",
              });
            })
            .catch((error) => {
              this.err_msg = HandleErrors.HandleErrors(error);
              this.apiErrModalShow = true;
            });
      },
      onReject: function () {
          const fd = new FormData();
          fd.append("uploaded_file_id", this.id);
          fd.append("notes", this.notes);
          HTTP.post("/api/vectraits-reject/", fd)
            .then(response => { 
              this.err_msg = response.data.err_msg;
              this.$notify({
                text: "File rejected successfully!",
                duration: 10000,
                type: "success",
              });
            })
            .catch((error) => {
              this.err_msg = HandleErrors.HandleErrors(error);
              this.apiErrModalShow = true;
            });
      },
      downloadFile(){
        // build the params object to be sent with the request.
        var params = new URLSearchParams();
        // params.append(<KEY>, <VALUE>)

        var request = {
            params: params,
            responseType: "arraybuffer",
        };

        HTTP.get(this.file_url, request)
          .then((response) => {
              var fileURL = window.URL.createObjectURL(
                  new Blob([response.data])
              );
              var fileLink = document.createElement("a");
              fileLink.href = fileURL;
              var fileName = this.file_name;
              fileLink.setAttribute("download", fileName);
              document.body.appendChild(fileLink);
              fileLink.click();
          })
          .catch((error) => { // executes whenever there is a response that is not a 200
            this.err_msg = HandleErrors.HandleErrors(error);
            this.apiErrModalShow = true;
          });
      },
    },
};
</script>

<style scoped>
.button-link {
  color: white !important;
}
  
</style>